import { render, staticRenderFns } from "./BoxFour.vue?vue&type=template&id=7d0ddbd8&scoped=true"
import script from "./BoxFour.vue?vue&type=script&lang=js"
export * from "./BoxFour.vue?vue&type=script&lang=js"
import style0 from "./BoxFour.vue?vue&type=style&index=0&id=7d0ddbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ddbd8",
  null
  
)

export default component.exports